function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["onOpenAutoFocus", "titleClass", "buttonVertical", "arrowEnable", "arrowHandler", "direction", "isMobile", "size", "confirmBtnDisabled", "title", "subTitle", "open", "className", "overlayClassName", "zIndex", "onOk", "onCancel", "onClose", "titleCenter", "wrapClassName", "contextWrapper", "width", "height", "contentHeight", "contentHeightAnimate", "okText", "type", "footerWrapper", "headerWrapper", "cancelText", "footer", "closable", "modal", "maskClosable", "confirmLoading", "cancelLoading", "draggable", "lockScroll"];
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useRTL } from "../../../hooks/useRTL";
import { useTheme } from "../../../lib/hooks";
import { cn } from "../../../lib/utils";
import { CloseIcon, DirectionleftIcon } from '@bfe/moly-icons';
import { IconButton } from "../iconbutton";
import * as Dialog from '@radix-ui/react-dialog';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import * as styles from "../../style/modal";
import { Image } from "../image";
import DarkDraggableIcon from "./DarkDraggableIcon";
import { Footer } from "./Footer";
import LightDraggableIcon from "./LightDraggableIcon";
import useLockBodyScroll from "./hooks/useLockBodyScroll";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Modal = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var onOpenAutoFocus = _ref.onOpenAutoFocus,
    titleClass = _ref.titleClass,
    buttonVertical = _ref.buttonVertical,
    arrowEnable = _ref.arrowEnable,
    arrowHandler = _ref.arrowHandler,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'default' : _ref$direction,
    isMobile = _ref.isMobile,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    confirmBtnDisabled = _ref.confirmBtnDisabled,
    title = _ref.title,
    subTitle = _ref.subTitle,
    open = _ref.open,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$overlayClassName = _ref.overlayClassName,
    overlayClassName = _ref$overlayClassName === void 0 ? '' : _ref$overlayClassName,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? 1000 : _ref$zIndex,
    onOk = _ref.onOk,
    onCancel = _ref.onCancel,
    onClose = _ref.onClose,
    titleCenter = _ref.titleCenter,
    wrapClassName = _ref.wrapClassName,
    contextWrapper = _ref.contextWrapper,
    width = _ref.width,
    height = _ref.height,
    _ref$contentHeight = _ref.contentHeight,
    contentHeight = _ref$contentHeight === void 0 ? 'auto' : _ref$contentHeight,
    _ref$contentHeightAni = _ref.contentHeightAnimate,
    contentHeightAnimate = _ref$contentHeightAni === void 0 ? false : _ref$contentHeightAni,
    _ref$okText = _ref.okText,
    okText = _ref$okText === void 0 ? 'Ok' : _ref$okText,
    type = _ref.type,
    _ref$footerWrapper = _ref.footerWrapper,
    footerWrapper = _ref$footerWrapper === void 0 ? '' : _ref$footerWrapper,
    _ref$headerWrapper = _ref.headerWrapper,
    headerWrapper = _ref$headerWrapper === void 0 ? '' : _ref$headerWrapper,
    _ref$cancelText = _ref.cancelText,
    cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText,
    footer = _ref.footer,
    _ref$closable = _ref.closable,
    closable = _ref$closable === void 0 ? true : _ref$closable,
    _ref$modal = _ref.modal,
    modal = _ref$modal === void 0 ? true : _ref$modal,
    _ref$maskClosable = _ref.maskClosable,
    maskClosable = _ref$maskClosable === void 0 ? false : _ref$maskClosable,
    _ref$confirmLoading = _ref.confirmLoading,
    confirmLoading = _ref$confirmLoading === void 0 ? false : _ref$confirmLoading,
    _ref$cancelLoading = _ref.cancelLoading,
    cancelLoading = _ref$cancelLoading === void 0 ? false : _ref$cancelLoading,
    _ref$draggable = _ref.draggable,
    draggable = _ref$draggable === void 0 ? false : _ref$draggable,
    _ref$lockScroll = _ref.lockScroll,
    lockScroll = _ref$lockScroll === void 0 ? true : _ref$lockScroll,
    props = _objectWithoutProperties(_ref, _excluded);
  var isRTL = useRTL();
  var _useTheme = useTheme(),
    _useTheme2 = _slicedToArray(_useTheme, 1),
    theme = _useTheme2[0];
  var _useState = useState(open),
    _useState2 = _slicedToArray(_useState, 2),
    openBool = _useState2[0],
    setOpenBool = _useState2[1];
  var _useState3 = useState(zIndex),
    _useState4 = _slicedToArray(_useState3, 2),
    modalZIndex = _useState4[0],
    setModalZIndex = _useState4[1];
  useLockBodyScroll({
    openBool: openBool,
    lockScroll: lockScroll
  });
  useEffect(function () {
    if (openBool) {
      var allModal = document.querySelectorAll('.moly-dialog-shadow');
      var maxZIndex = '0';
      allModal.forEach(function (v) {
        maxZIndex = v.style.zIndex;
      });
      if (parseInt(maxZIndex) >= zIndex) {
        setModalZIndex === null || setModalZIndex === void 0 || setModalZIndex(parseInt(maxZIndex) + 1);
      }
    } else {}
  }, [openBool, zIndex]);
  var dragStartX = useRef(0);
  var dragStartY = useRef(0);
  var isDragging = useRef(false);

  // 记录modal 当前距离视口左上角的偏移量
  var modalPosition = useRef({
    x: 0,
    y: 0
  });

  // 鼠标按下事件
  var handleMouseDown = function handleMouseDown(e) {
    var _e$target;
    if (!draggable || (e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.id) === 'closeIcon') {
      return;
    }
    isDragging.current = true;
    dragStartX.current = e.clientX;
    dragStartY.current = e.clientY;
  };

  // 用 useCallback 包一下，解决 exhaustive-deps lint 报错
  // https://github.com/facebook/react/issues/14920
  // 开始移动
  var handleMouseMove = useCallback(function (e) {
    if (!isDragging.current || !draggable) return;
    var offsetX = e.clientX - dragStartX.current;
    var offsetY = e.clientY - dragStartY.current;
    var modalElement = document.querySelector('.moly-modal');
    var modalRect = modalElement === null || modalElement === void 0 ? void 0 : modalElement.getBoundingClientRect();
    var rightBoundary = window.innerWidth - (modalRect === null || modalRect === void 0 ? void 0 : modalRect.width) || 0;
    var bottomBoundary = window.innerHeight - (modalRect === null || modalRect === void 0 ? void 0 : modalRect.height) || 0;
    var currentMPX = modalPosition.current.x;
    var currentMPY = modalPosition.current.y;

    // 首次移动需要获取当前modal 的偏移量
    if (!modalPosition.current.x || !modalPosition.current.y) {
      currentMPX = (modalRect === null || modalRect === void 0 ? void 0 : modalRect.left) + (modalRect === null || modalRect === void 0 ? void 0 : modalRect.width) / 2;
      currentMPY = (modalRect === null || modalRect === void 0 ? void 0 : modalRect.top) + (modalRect === null || modalRect === void 0 ? void 0 : modalRect.height) / 2;
    }
    var newX = currentMPX + offsetX;
    var newY = currentMPY + offsetY;
    if (newX < (modalRect === null || modalRect === void 0 ? void 0 : modalRect.width) / 2) {
      newX = (modalRect === null || modalRect === void 0 ? void 0 : modalRect.width) / 2;
    }
    if (newX > rightBoundary + (modalRect === null || modalRect === void 0 ? void 0 : modalRect.width) / 2) {
      newX = rightBoundary + (modalRect === null || modalRect === void 0 ? void 0 : modalRect.width) / 2;
    }
    if (newY < (modalRect === null || modalRect === void 0 ? void 0 : modalRect.height) / 2) {
      newY = (modalRect === null || modalRect === void 0 ? void 0 : modalRect.height) / 2;
    }
    if (newY > bottomBoundary + (modalRect === null || modalRect === void 0 ? void 0 : modalRect.height) / 2) {
      newY = bottomBoundary + (modalRect === null || modalRect === void 0 ? void 0 : modalRect.height) / 2;
    }
    if (modalElement && modalElement !== null && modalElement !== void 0 && modalElement.style) {
      modalElement.style.top = "".concat(newY, "px");
      modalElement.style.left = "".concat(newX, "px");
    }
    modalPosition.current = {
      x: newX,
      y: newY
    };
    dragStartX.current = e.clientX;
    dragStartY.current = e.clientY;
  }, [draggable]);

  // 鼠标up
  var handleMouseUp = function handleMouseUp() {
    isDragging.current = false;
  };
  useEffect(function () {
    if (!draggable) {
      return;
    }
    document.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    return function () {
      document.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [draggable, handleMouseMove]);
  var iconMap = {
    successful: 'https://s1.bycsi.com/bybit/deadpool/image-a94c1c9e32e74d0696a47a434310a189.svg',
    failed: 'https://s1.bycsi.com/bybit/deadpool/image-84f00a214fb54eacbc2ec92086433b3f.svg',
    alert: 'https://s1.bycsi.com/bybit/deadpool/image-88a487697968406faa1aa1918f1287e8.svg',
    pending: 'https://s1.bycsi.com/bybit/deadpool/image-ce5dd07f6a53413f825a09b9a5579d99.svg'
  };
  useEffect(function () {
    if (open) {
      isDragging.current = false;
      dragStartX.current = 0;
      dragStartY.current = 0;
      modalPosition.current = {
        x: 0,
        y: 0
      };
      setTimeout(function () {
        document.body.style.pointerEvents = 'initial';
      }, 100);
    }
    setOpenBool(open);
  }, [open, setOpenBool]);
  var handleClose = function handleClose() {
    if (typeof onClose === 'function') {
      onClose();
    } else {
      onCancel === null || onCancel === void 0 || onCancel();
    }
  };
  var modalWidth = width;
  if (isMobile) {
    modalWidth = 'calc(100vw - 48px)';
    if (direction === 'bottom') {
      modalWidth = '100vw';
    }
  }
  var contentRender = function contentRender() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [!draggable && /*#__PURE__*/_jsx("div", {
        style: {
          zIndex: modalZIndex,
          pointerEvents: 'auto'
        },
        className: cn('moly-dialog-shadow', styles.molyModalOpen, overlayClassName, 'font-IBM', !open ? styles.molyModalClose : '')
      }), /*#__PURE__*/_jsxs(Dialog.Content, {
        style: {
          width: modalWidth,
          height: height,
          zIndex: modalZIndex + 1
        },
        "data-open": open ? 'open' : 'closed',
        "data-direction": direction,
        className: cn('moly-modal pb-[24px] rounded-2xl  font-IBM', {
          'pt-[24px]': !draggable,
          'rounded-t-2xl': isMobile && direction === 'bottom',
          'rounded-b-none': isMobile && direction === 'bottom',
          'w-[780px]': !isMobile && !width && size === 'large',
          'w-[560px]': !isMobile && !width && size === 'medium',
          'w-[480px]': !isMobile && !width && size === 'small'
        }, styles.molyModalContainer, className),
        onEscapeKeyDown: handleClose,
        onPointerDownOutside: function onPointerDownOutside() {
          if (maskClosable) {
            handleClose();
          }
        },
        onOpenAutoFocus: onOpenAutoFocus,
        children: [/*#__PURE__*/_jsx("div", {
          className: cn('text-[18px] w-full leading-[26px] font-semibold', {
            'px-[32px]': !isMobile,
            'px-[24px]': isMobile,
            'text-left': isRTL,
            'text-right': !isRTL,
            'text-[20px] leading-[28px]  h-[24px] mr-[0px]': type,
            hidden: !title && !closable
          }),
          children: closable && type && /*#__PURE__*/_jsx(Dialog.Close, {
            asChild: true,
            children: /*#__PURE__*/_jsx(IconButton, {
              width: "24px",
              className: "w-[24px] h-[24px]",
              children: /*#__PURE__*/_jsx(CloseIcon, {
                id: "closeIcon",
                "aria-label": "Close",
                onClick: function onClick(e) {
                  e.stopPropagation();
                  handleClose();
                },
                className: cn('IconButton  leading-6 rounded inline-block text-[#81858c]  ')
              })
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: cn(headerWrapper),
          children: [type && /*#__PURE__*/_jsx("div", {
            className: cn('text-center'),
            children: /*#__PURE__*/_jsx(Image, {
              className: cn('w-[66px] h-[66px] mb-[16px] inline'),
              src: iconMap[type],
              alt: "success"
            })
          }), /*#__PURE__*/_jsxs(Dialog.Title, {
            className: cn('text-[18px] leading-[26px] font-semibold flex gap-x-2', {
              'px-[32px]': !isMobile,
              'px-[24px]': isMobile,
              'pt-[24px]': draggable,
              'cursor-move': draggable,
              'text-center': titleCenter,
              'text-[20px] leading-[28px] mr-[0px]': type,
              hidden: !title && !closable,
              'justify-end': !title
            }, titleClass),
            id: "dragEle",
            onMouseDown: handleMouseDown,
            children: [arrowEnable && /*#__PURE__*/_jsx(IconButton, {
              width: "24px",
              className: cn('w-[24px] h-[24px]'),
              children: /*#__PURE__*/_jsx(DirectionleftIcon, {
                onClick: function onClick() {
                  arrowHandler === null || arrowHandler === void 0 || arrowHandler();
                }
              })
            }), draggable && /*#__PURE__*/_jsx("div", {
              className: styles.molyModalDraggableIcon,
              children: theme === 'light' ? /*#__PURE__*/_jsx(LightDraggableIcon, {}) : /*#__PURE__*/_jsx(DarkDraggableIcon, {})
            }), /*#__PURE__*/_jsx("div", {
              className: "flex-1",
              children: title
            }), closable && !type && /*#__PURE__*/_jsx(Dialog.Close, {
              asChild: true,
              children: /*#__PURE__*/_jsx(IconButton, {
                width: "24px",
                className: "w-[24px] h-[24px] ",
                children: /*#__PURE__*/_jsx(CloseIcon, {
                  id: "closeIcon",
                  "aria-label": "Close",
                  onClick: handleClose,
                  className: cn('IconButton leading-6 rounded inline-block text-[#81858c] ')
                })
              })
            })]
          }), subTitle && /*#__PURE__*/_jsx(Dialog.Title, {
            className: cn('mt-[8px] text-[16px] leading-[24px] font-normal text-[#81858C] ', {
              'text-center': titleCenter,
              'px-[32px]': !isMobile,
              'px-[24px]': isMobile
            }),
            children: subTitle
          })]
        }), /*#__PURE__*/_jsx("div", {
          ref: ref,
          className: cn(contextWrapper, styles.molyModalContent, 'font-IBM', title ? '' : 'unhave-header', _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles.molyModalContentH5, isMobile), 'px-[32px]', !isMobile), 'px-[24px]', isMobile), 'overflow-y-scroll max-h-[440px]', isMobile), 'transition-all duration-300 ease-in-out', contentHeightAnimate), "hidden", !(props !== null && props !== void 0 && props.children)), wrapClassName),
          style: {
            height: contentHeight
          },
          children: props === null || props === void 0 ? void 0 : props.children
        }), /*#__PURE__*/_jsx(Footer, {
          size: size,
          buttonVertical: buttonVertical,
          isMobile: isMobile,
          footerWrapper: footerWrapper,
          confirmBtnDisabled: confirmBtnDisabled,
          footer: footer,
          onOk: onOk,
          onCancel: onCancel,
          okText: okText,
          cancelText: cancelText,
          confirmLoading: confirmLoading,
          cancelLoading: cancelLoading
        })]
      })]
    });
  };
  return /*#__PURE__*/_jsx(Dialog.Root, {
    open: openBool,
    modal: modal,
    children: /*#__PURE__*/_jsx(Dialog.Portal, {
      children: contentRender()
    })
  });
});
Modal.displayName = 'Modal';
export { Modal };